import { useEffect, useState } from "react";

type Viewport = { width: number; remPx: number };

const measure = (): Viewport => ({
  width: window.innerWidth,
  remPx: Number.parseFloat(getComputedStyle(document.documentElement).fontSize) || 16,
});

export const useViewport = (): Viewport => {
  const [viewport, setViewport] = useState(measure);
  useEffect(() => {
    const update = () =>
      setViewport((previous) => {
        const next = measure();
        return next.width === previous.width && next.remPx === previous.remPx ? previous : next;
      });
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  return viewport;
};
